<div class="full-height layout-column">
  <div class="layout-column">

    @if (hasDeliveriesListPermission) {
      <bz-tabs class="full-width threepl-services-nav-tabs"
               appBringozIdGenerator="threepl-services-nav-tabs"
               ariaLabel="Services tabs"
               [tabs]="servicesNavTabs"
               selectedId="threepl"
               (selectedIdChange)="onServicesNavChange($event)">
      </bz-tabs>
    }

    @if (!isMobile()) {
      <bz-tabs class="threepl-services-group-tabs"
               appBringozIdGenerator="threepl-services-group-tabs"
               [attr.data-group]="selectedGroupTab()"
               ariaLabel="navigation links"
               [tabs]="groupTabs()"
               [selectedId]="selectedGroupTab()"
               (selectedIdChange)="changeGroup($event)">
      </bz-tabs>
    }

    <div class="threepl-services-toolbar layout-row layout-align-start-center overflow-auto">
      @if (isMobile()) {
        <bz-menu appBringozIdGenerator="threepl-services-group-menu"
                 [ariaLabel]="'Status' | translate"
                 [items]="groupMenuItems()"
                 (selected)="onGroupMenuSelected($event)">
          <span class="layout-row layout-align-start-center threepl-menu-trigger">
            {{ (group() || 'Total') | translate }} {{ groupMenuCount() }}
            <bz-icon [icon]="icons.chevron"></bz-icon>
          </span>
        </bz-menu>
      }

      <app-bringoz-date-range-picker appBringozIdGenerator="threepl-services-date-range-picker"
                                     [selectedRange]="range()"
                                     [min]="rangeLimit.min"
                                     [max]="rangeLimit.max"
                                     [customTemplates]="customTemplates"
                                     (onChange)="onRangeChanged($event)">
      </app-bringoz-date-range-picker>

      <app-bringoz-time-picker [isDisabled]="isTimeSelectionDisabled()"
                               [range]="range()"
                               [isShowTimeWindowTab]="false"
                               (timeSelect)="onTimeSelect($event)">
      </app-bringoz-time-picker>

      <bz-search-input class="margin-left-10 threepl-services-search"
                       appBringozIdGenerator="filterSearchInput"
                       [placeholder]="'Search service' | translate"
                       [debounceMs]="1000"
                       [minLength]="4"
                       (valueChange)="submitQuery($event)">
      </bz-search-input>

      <app-bringoz-quick-filter-select appBringozIdGenerator="threepl-services-quick-filter"
                                       [selectedId]="selectedQuickFilterId()"
                                       [pageName]="pageName"
                                       (selectionChange)="onQuickFilterSelect($event.selectedItem)">
      </app-bringoz-quick-filter-select>

      <app-bringoz-filters-button appBringozIdGenerator="threepl-services-filters-button"
                                  [includeFilters]="includeFilters"
                                  [filters]="filters()"
                                  [selectedQuickFilterId]="selectedQuickFilterId()"
                                  [pageName]="pageName"
                                  [queryMap]="queryMap"
                                  (onChange)="onFiltersChange($event.filters, $event.selectedQuickFilter)">
      </app-bringoz-filters-button>

      <span class="flex"></span>

      <!-- ui-fallback: mat-menu (what bz-menu is built on, same panel look) because the export items carry icons and bz-menu items are label-only. -->
      <span class="threepl-toolbar-icon-button" container="body" placement="left"
            [ngbTooltip]="(listEmpty() ? 'Can’t export empty table' : 'Export') | translate">
        <bz-button variant="tertiary" size="fit" appBringozIdGenerator="threepl-services-export-button"
                   [ariaLabel]="'Export' | translate"
                   [disabled]="listEmpty()"
                   [matMenuTriggerFor]="exportMenu"
                   (click)="onExportTriggerClick($event)">
          <bz-icon class="threepl-toolbar-icon" [icon]="icons.exportXsl"></bz-icon>
        </bz-button>
      </span>
      <mat-menu #exportMenu="matMenu" class="threepl-services-export-menu">
        <!-- ui-fallback: mat-menu item, see above. -->
        <button mat-menu-item type="button" appBringozIdGenerator="threepl-services-export-excel" (click)="onExport(lastExportTriggerClick, exportTypes.Excel)">
          <bz-icon matMenuItemIcon [icon]="icons.export"></bz-icon>
          <span class="br-body-2">{{ 'Excel' | translate }}</span>
        </button>
        <!-- ui-fallback: mat-menu item, see above. -->
        <button mat-menu-item type="button" appBringozIdGenerator="threepl-services-export-csv" (click)="onExport(lastExportTriggerClick, exportTypes.CSV)">
          <bz-icon matMenuItemIcon [icon]="icons.export"></bz-icon>
          <span class="br-body-2">{{ 'CSV' | translate }}</span>
        </button>
      </mat-menu>

      <app-threepl-services-settings-panel [settings]="settings()" (settingsChange)="onViewSettingsChange($event)"></app-threepl-services-settings-panel>
    </div>
  </div>

  <app-threepl-services-table class="flex"
                              [items]="vm().items"
                              [loading]="vm().loading"
                              [columns]="settings().columns"
                              [dynamicColumns]="settings().dynamicColumns"
                              [layout]="settings()"
                              [sortType]="sortValue()"
                              [selectedServiceIds]="selectedServiceIds()"
                              (toggleService)="onToggleService($event)"
                              (addNote)="onAddNoteToService($event)"
                              (moveToInternal)="onMoveToInternal($event)"
                              (cancel)="onCancelService($event)"
                              (sortTypeChange)="onSortTypeChange($event)"
                              (fetchNext)="store.loadMore()"
                              (layoutChange)="onTableLayoutChange($event)">
  </app-threepl-services-table>

  @if (selectedServiceIds().length) {
    <app-threepl-service-action-footer [selectedServices]="selectedServices()"
                                       (unselectAll)="onUnselectAll()"
                                       (cancelServices)="onCancelSelectedServices()"
                                       (addNoteToServices)="onAddNoteToSelectedServices($event)">
    </app-threepl-service-action-footer>
  }
</div>
